import VideoCard, { AddVideoCard } from './VideoCard'

export default VideoCard;
export {
    AddVideoCard
}
